import cx from 'classnames'
import { motion } from 'motion/react'
import { FC, useMemo } from 'react'
import { motionSlide } from 'src/hooks/useAppear'

import { ActionCardProps } from '../ActionCard'
import { BlockTitleProps } from '../BlockTitle'

import * as SC from './styled'

export type ActionGridProps = {
  className?: string
  blockTitleProps?: BlockTitleProps
  actions?: ActionCardProps[]
  color?: string
  forcedRatio?: number
}

const ActionGrid: FC<ActionGridProps> = ({
  className,
  blockTitleProps,
  actions,
  color,
  forcedRatio,
}) => {
  const { motions } = useActionGridMotion()

  return (
    <SC.Container className={cx('ActionGrid', className)}>
      {blockTitleProps && <SC._BlockTitle {...blockTitleProps} color={color} />}
      {actions && actions.length > 0 && (
        <SC.Grid>
          {actions.map((action, index) => (
            <motion.li
              key={`action-card-${index}`}
              {...(index % 2 ? motions.actionDelayed : motions.action)}
            >
              <SC._ActionCard {...action} $ratio={forcedRatio} />
            </motion.li>
          ))}
        </SC.Grid>
      )}
    </SC.Container>
  )
}

const useActionGridMotion = () => {
  const motions = useMemo(
    () => ({
      action: motionSlide({}).motionProps,
      actionDelayed: motionSlide({ delay: 0.12 }).motionProps,
    }),
    []
  )

  return { motions }
}

export default ActionGrid
